import { apiClient } from './client';
import type { ApiResponse, PagedResult } from '@/types/api.types';
import type {
  CardChargebackDto,
  CardChargebackFilterDto,
} from '@/types/cardReconciliation.types';

export const cardChargebackApi = {
  /** GET /api/v1/card-chargebacks — paginated list */
  getList: (filter?: CardChargebackFilterDto) =>
    apiClient.get<ApiResponse<PagedResult<CardChargebackDto>>>('/card-chargebacks', { params: filter }),

  /** POST /api/v1/card-chargebacks */
  create: (data: {
    chargebackNo:         string;
    cardAcquirerId:       string;
    originalSaleReference?: string | null;
    originalTransactionId?: string | null;
    chargebackDate:       string;
    chargebackReason?:    string | null;
    amount:               number;
    chargebackAccountId?: string | null;
    notes?:               string | null;
  }) =>
    apiClient.post<ApiResponse<{ id: string }>>('/card-chargebacks', data),

  /** POST /api/v1/card-chargebacks/{id}/action — Accept | Dispute | Recover | WriteOff */
  action: (id: string, action: string, notes?: string | null) =>
    apiClient.post<ApiResponse<object>>(`/card-chargebacks/${id}/action`, { action, notes }),
};
